import React from 'react';
import useStyles from './styles';
import { Icon } from '@livable/saas-react-components';
import { Typography, Button, Grid } from '@mui/material';
import { MovePropertiesModal } from '../MovePropertiesModal';
import { observer } from 'mobx-react-lite';
import { CreateEditPortfolioModal } from 'src/components/shared/CreateEditPortfolioModal';
import { useStore } from 'src/stores';
import { useTranslation } from 'react-i18next';
import { ManageAccessModal } from 'src/components/shared/ManageAccessModal';
export const ActivePropertiesActions = observer(_ref => {
  let triggerRefresh = _ref.triggerRefresh;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const trigger = function (title, type) {
    let disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      disabled: disabled,
      'custom-attribute': '671-new-billing-module-' + type
    }, /*#__PURE__*/React.createElement(Icon, {
      type: type
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, title));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.actionsWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Batch actions:"), /*#__PURE__*/React.createElement("div", {
    className: classes.desktopActions
  }, /*#__PURE__*/React.createElement(CreateEditPortfolioModal, {
    key: 'ActivePropertiesActions-CreateEditPortfolio',
    customTrigger: trigger(t('portfolios_properties_page.group_into_portfolio'), 'folder-house'),
    triggerRefresh: triggerRefresh,
    isCreateAndMoveProperties: true
  }), /*#__PURE__*/React.createElement(MovePropertiesModal, {
    key: 'ActivePropertiesActions-MovePropertiesModal',
    customTrigger: trigger(t('portfolios_properties_page.move'), 'user-transfer'),
    triggerRefresh: triggerRefresh
  }), !store.account.userProfile.isUserPropertyManagerRegular && /*#__PURE__*/React.createElement(ManageAccessModal, {
    key: 'ActivePropertiesActions-ManageAccessModal',
    isEditMode: false,
    customTrigger: trigger(t('team_page.manage_access'), 'user-add'),
    triggerRefresh: triggerRefresh,
    isBatchOp: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.tabletActions
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 7,
    rowSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(CreateEditPortfolioModal, {
    key: 'ActivePropertiesActions-CreateEditPortfolio',
    customTrigger: trigger(t('portfolios_properties_page.group_into_portfolio'), 'folder-house'),
    triggerRefresh: triggerRefresh,
    isCreateAndMoveProperties: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(MovePropertiesModal, {
    key: 'ActivePropertiesActions-MovePropertiesModal',
    customTrigger: trigger(t('portfolios_properties_page.move'), 'folder-share'),
    triggerRefresh: triggerRefresh
  })), !store.account.userProfile.isUserPropertyManagerRegular && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(ManageAccessModal, {
    key: 'ActivePropertiesActions-ManageAccessModal',
    isEditMode: false,
    customTrigger: trigger(t('team_page.manage_access'), 'user-add'),
    triggerRefresh: triggerRefresh,
    isBatchOp: true
  })))));
});